import { useRegisterSW } from 'virtual:pwa-register/react'

export function ReloadPrompt() {
  useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (registration) {
        setInterval(() => {
          registration.update()
        }, 60 * 1000)
      }
    },
    onNeedRefresh() {
      window.location.reload()
    },
  })

  return null
}
